import hh from 'hyperscript-helpers';
import { h } from 'virtual-dom';

import Draw from 'ol/interaction/Draw.js';

import {
    uploadFilUploadMsg, emailUploadMsg, pinUploadMsg, titleUploadMsg, kortTitelUploadMsg, undertitelUploadMsg, forfatterUploadMsg,
    udgivelsesDatoUploadMsg, siderUploadMsg, isbnUploadMsg,
    keywordSelectUploadMsg, methodSelectUploadMsg, centerSelectUploadMsg,
    /* --- Lov, Formål, Kommune --- */
    lawsSelectUploadMsg, purposeSelectUploadMsg, municipalitySelectUploadMsg, searchMunicipalityInputMsg,
    uploadMsg, clearUploadStatusBannerMsg, editMsg,
    highlightDragMsg, dropDragMsg, removeFilesMsg, removeOldFileMsg,georefUploadMsg, removeWktMsg,
    georefStringUploadMsg, geoRefDrawTypeMsg, //georefDrawUploadMsg,
    /* --- tabs --- */
    tabMsg,
    /* --- dgu --- */
    selectDguMsg, addDguBtnMsg,
    dguUploadMsg, getDguInfoMsg, removeDguMsg,
    /* --- geofys ---*/
    geoFysTextMsg, getGeoFysTextSearchBtnMsg, addGeoFysBtnMsg, selectGeoFysMsg, removeAddedGeoFysProject,
    /* --- modeller --- */
    modelLinkMsg, addModelLinkBtnMsg, removeAddedModelMsg,
    /* --- select area Nøgleord Metoder, mv --- */
    tabSelectAreaMsg
} from "../updates/UploadUpdate";
import { showLoginMsg, showOrderPinMsg, showFrontPageMsg } from "../Update";
import { getButton, getSubmitButton } from "./View";
import drawMap from "./MapView";

const { div, p, main, fieldset, legend, textarea, i, span, li, ul, h5,
    select, option, input, label, button, form, a, pre } = hh(h);

let mapModel; // global var necessary to prevent multiple maps from being rendered

function getSelectedOptions(selectId, dispatch, inputMsg) {
    const selectElement = document.querySelector('#'+ selectId);
    const selectedOptionValues = [...selectElement.options].filter(el => el.selected).map(el => el.value );
    dispatch(inputMsg(selectedOptionValues));
}
function displayRadioValue(dispatch, inputMsg) {
    const radioElements = document.getElementsByName('drawType');
    for (const element of radioElements) {
      if (element.checked)
        dispatch(inputMsg(element.value));
    }
}
export function uploadView(dispatch, model) {
    if ( !model.upload.email && model.login.email ) dispatch(emailUploadMsg(model.login.email));

    // if (model.state.edit) {
    //
    // }

    return div({ className: '' }, [
            showSuccess(dispatch, model.upload),
            uploadForm(dispatch, model),
            // pre( { className: 'mw-50' },  JSON.stringify(model, null, 2)),
        ]);
}
function showTabs(dispatch, model) {
    let metaDataStyle = 'link dim pointer f6 b dib mr1 mr5-ns ';
    let filesStyle = 'link dim pointer f6 b dib mr1 mr5-ns ';
    let otherStyle = 'link dim pointer f6 b dib ';
    if (model.upload.tab === 'metadata') {
        metaDataStyle += 'black-70';
        filesStyle += 'black-30';
        otherStyle += 'black-30';
    }
    if (model.upload.tab === 'files') {
        metaDataStyle += 'black-30';
        filesStyle += 'black-70';
        otherStyle += 'black-30';
    }
    if (model.upload.tab === 'other') {
        metaDataStyle += 'black-30';
        filesStyle += 'black-30';
        otherStyle += 'black-70';
    }
    return div( { className: 'tc pa3 bg-light-gray' }, [
        a( { className: metaDataStyle, onclick: () => dispatch(tabMsg('metadata')) }, '1. METADATA'),
        a( { className: filesStyle, onclick: () => dispatch(tabMsg('files')) }, '2. FILER'),
        a( { className: otherStyle, onclick: () => dispatch(tabMsg('other')) }, '3. ØVRIGE'),
    ]);
}
function showError(dispatch, model) {
    if (model.upload.error) {
        return div( { id: 'result', className: 'w-60-ns center tc red mb1 b' }, [
            i( { className: 'fl mr1 red fa fa-exclamation-circle fa-2x' }),
            p( { className: 'mt0' }, model.upload.error)
        ]);
    }
    if (model.showSure) {
        return div( { id: 'result', className: 'w-60-ns center tc black-50 mb1 b' }, [
                i( { className: 'fl mr1 orange fa fa-exclamation-circle fa-2x' }),
                p( { className: 'mt0' }, 'Der er ikke vedhæftet nogle filer. Tryk på "Indsend rapport" for at oprette rapporten alligevel.'),
            ]
        );
    }

    return '';
}
function showSuccess(dispatch, model) {
    if (model.success === 'SUCCESS') {
        setTimeout(function() {
            dispatch(clearUploadStatusBannerMsg);
        }, 4000);
        return div({
            id: 'result',
            className: 'modal baskerville'
        }, div({className: 'modal-content b--green'}, [
                div( { className: 'bg-green white pt2 pb2 tc' } , i( { className: 'fa fa-check-circle-o fa-5x'} ) ),
                div( { className: 'bg-near-white black-80' } , [
                    p( { className: 'f2 tc mt0 pt3' }, 'Modtaget!'),
                    p( { className: 'f4 tc mb0 pb4' }, 'Tak for rapporten.'),
                ]),
           ])
        );
    }
    return '';
}
function uploadForm(dispatch, model) {
    const submitBtnDisabled = !model.upload.title || !model.upload.email || !model.upload.pin ? 'disabled' : '';
    if (model.upload.success !== 'SUCCESS') {
        setTimeout(function() {
            drawMapView(dispatch, model);
        }, 500);
    }
    return main({ className: 'mt4 pv3 black-80 w-60-ns center bg-white-90' }, [
        form( {
                className: 'flex-auto-ns w-100 mw6-ns center',
                onsubmit: e => {
                    if (e.keyCode === 13) { // prevent submit on ENTER
                        console.log('You have pressed Enter key, click submit button instead');
                        return false;
                    }
                    e.preventDefault();
                    model.state === 'edit' ? dispatch(editMsg) : dispatch(uploadMsg);
                },
            }, [
                fieldset( { id: 'upload', className:'ba b--transparent ph0 mh0 w-100'}, [
                    model.state === 'edit' ? legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Redigér grundvandsrapport ' + model.rapportid ) : legend( { className: 'tc f3 f2-m f2-l fw2 black-90 mv3' } , 'Indsend grundvandsrapport'),
                    div({ className: '' }, [
                        p( { className: 'f4 fw6 ph0 mh0' } , 'Bruger'),
                        div({ className: 'mt3' }, [
                            input({
                                className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-60',
                                placeholder: 'Email',
                                id: 'loginEmail',
                                value: model.upload.email,
                                type: 'text',
                                oninput: e => dispatch(emailUploadMsg(e.target.value)),
                            }),
                            input({
                                className: 'fr pa2 input-reset ba br2 bg-transparent hover-black-80 w-34',
                                placeholder: 'Pinkode',
                                type: 'password',
                                autocomplete: 'current-password',
                                value: model.upload.pin,
                                oninput: e => dispatch(pinUploadMsg(e.target.value)),
                            }),
                            div( { className: 'lh-copy mt1 mb1 fr' }, a( { className: 'f6 link dim black db pointer', onclick: () => dispatch(showOrderPinMsg)}, 'Bestil ny pinkode') ),
                        ]),
                        p( { className: 'f4 fw6 ph0 mh0' } , 'Rapport'),
                        div({ className: 'mt3' }, [
                            label({ className: 'pa2 mb1' }, [ 'Titel', span( { className: 'f6 black-50'}, ' (skal udfyldes)') ]),
                            inputField(dispatch, titleUploadMsg, 'titel', model.upload.title)
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Korttitel'),
                            inputField(dispatch, kortTitelUploadMsg, 'korttitel', model.upload.shortTitle)
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Undertitel'),
                            textarea({
                                className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-100',
                                id: 'subTitle',
                                rows: 2,
                                value: model.upload.subTitle,
                                oninput: e => dispatch(undertitelUploadMsg(e.target.value)),
                            })],
                        ),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Forfattere'),
                            inputField(dispatch, forfatterUploadMsg, 'forfattere', model.upload.author)
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Udgivelsesdato'),
                            input({
                                className: 'pa2 input-reset ba br2 bg-transparent hover-black-80',
                                type: 'date',
                                value: model.upload.publishDate,
                                oninput: e => dispatch(udgivelsesDatoUploadMsg(e.target.value)),
                            })],
                        ),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Antal sider'),
                            inputField(dispatch, siderUploadMsg, 'sider', model.upload.pages)
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'ISBN'),
                            inputField(dispatch, isbnUploadMsg, 'isbn', model.upload.isbn)
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Lovgrundlag'),
                            select({
                               className: 'pa2 black-70 f6 w-100 br2 ba',
                               id: 'searchLaws',
                               name: 'searchLaws',
                               onchange: e => getSelectedOptions('searchLaws', dispatch, lawsSelectUploadMsg)
                            },
                               model.constLists.searchLaws.map(
                                   function (item, index) {
                                       const selectedOption = model.upload.selectedLaws[0] === item.kode;
                                       return option({ value: item.kode, selected: selectedOption }, item.text);
                                   }
                               ))
                        ]),
                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Formål'),
                            select({
                               className: 'pa2 black-70 f6 w-100 br2 ba',
                               id: 'searchPurpose',
                               name: 'searchPurpose',
                               onchange: e => getSelectedOptions('searchPurpose', dispatch, purposeSelectUploadMsg)
                            },
                            model.constLists.searchPurpose.map(
                                function (item, index) {
                                    const selectedOption = model.upload.selectedPurpose[0] === item.kode;
                                    return option({ value: item.kode, selected: selectedOption }, item.text);
                                }
                            ))
                        ]),

                        div({ className: 'mv3' }, [
                            label({ className: 'pa2 mb1' }, 'Kommune'),
                            input({
                                className: 'mv1 pt2 pb2 pl2 input-reset ba bg-transparent hover-black-80 w-100 br2',
                                value: model.upload.selectedMunicipality && model.upload.selectedMunicipality.length > 0 ? model.constLists.searchMunicipality.find(m => m.kode===model.upload.selectedMunicipality[0]).text : model.upload.searchedMunicipality,
                                type: 'text',
                                placeholder: 'Kommunenavn eller -nummer',
                                oninput: e => dispatch(searchMunicipalityInputMsg(e.target.value))
                            }),
                            model.upload.searchedMunicipality ? select({
                                   className: 'pa2 black-70 f6 w-100 br2 ba',
                                   id: 'searchMunicipality',
                                   name: 'searchMunicipality',
                                   size: 5,
                                   onchange: e => getSelectedOptions('searchMunicipality', dispatch, municipalitySelectUploadMsg)
                                },
                                model.constLists.searchMunicipality.filter(m => m.text.toLowerCase().indexOf(model.upload.searchedMunicipality.toLowerCase()) > -1 || m.nummer.indexOf(model.upload.searchedMunicipality) > -1 ).map(
                                    function (item, index) {
                                        const selectedOption = model.upload.selectedMunicipality === item.kode;
                                        return option({ value: item.kode, selected: selectedOption }, (item.text + ' ('+item.nummer+')' ) );
                                    }
                                )) : '',
                        ]),

                        div({ className: 'mv3-ns' }, [
                            div({ className: 'pa2 dib' }, [
                                selectAreaLabelLink(model, dispatch, 'tabKeyword', 'Nøgleord'),
                                selectAreaLabelLink(model, dispatch, 'tabMethod', 'Metoder'),
                                selectAreaLabelLink(model, dispatch, 'tabCenter', 'Miljøcentre'),
                            ]),
                            selectAreaOptions(model, dispatch),
                            div( { className: 'tc' }, label( { className: 'black-50 i f7-l f6' }, 'Brug CTRL+klik for at vælge flere.')),
                        ]),
                        label({ className: 'pa2' }, 'Tilføj filer'),
                        div({  className: 'tr' }, [
                            addFileUploadArea(dispatch, model),
                            a( { className: 'black-60 link dim pointer f6-l f5', title: 'Fjern', onclick: () => dispatch(removeFilesMsg)}, 'Fjern filer'),
                        ]),
                        model.state === 'edit' ?
                            renderAddedList(dispatch, model.upload.oldFiles, 'Tilføjede filer', removeOldFileMsg) : '' ,
                        addDguBoring(dispatch, model),
                        addGeoFysProject(dispatch, model),
                        addModelLink(dispatch, model),
                        addGeoReference(dispatch, model),
                    ]),
                ]),
                showError(dispatch, model),
                div({  className: 'tc' },
                     getSubmitButton( model.state === 'edit' ? 'Redigér rapport' : 'Indsend rapport', submitBtnDisabled)
                ),

                div( { className: 'lh-copy tc mt3' }, a( { className: 'f6 link dim black db pointer', onclick: () => dispatch(showFrontPageMsg)}, 'Fortryd') )
            ],
        ),
    ]);

    function drawMapView(dispatch, model) {
        // if map already drawn do nothing
        if (document.getElementById('map').innerHTML !== "" && mapModel) {
            toggleDrawLayer(model);
            return;
        }
        mapModel = drawMap(dispatch, georefStringUploadMsg);
        mapModel.setTarget('map');
        toggleDrawLayer(model);
    }
    function toggleDrawLayer(model) {
        const value = model.upload.drawType;
        const allInteractions = mapModel.getInteractions();
        allInteractions.forEach((interaction) => {
            if (interaction instanceof Draw) {
                if (interaction.get('name') === value)
                    interaction.setActive(true);
                else
                    interaction.setActive(false);
            }
        });
    }

    /* --------------------------------------*/
    function selectAreaLabelLink(model, dispatch, tabName, labelName) {
        const className = model.upload.selectArea === tabName ? 'black-70' : 'black-30';
        return a(
            { className: 'link dim pointer mr2', onclick: () => dispatch(tabSelectAreaMsg(tabName)) },
            label({ className: className }, labelName)
        );
    }
    function selectAreaOptions(model, dispatch) {
        if (model.upload.selectArea === 'tabKeyword') {
            return select({
                   className: 'black-60 f6 w-100 br2 ba',
                   id: 'searchKeyword',
                   name: 'searchKeyword',
                   size: 10,
                   multiple: true,
                   onchange: e => getSelectedOptions('searchKeyword', dispatch, keywordSelectUploadMsg),
               },
               model.constLists.searchKeywords.map(
                   function (item, index) {
                       const selectedOption = model.upload.selectedKeyword.includes(item.kode);
                       return option({ value: item.kode, selected: selectedOption }, item.text);
                   }
               )
           );
       }
       if (model.upload.selectArea === 'tabMethod') {
           return select({
                  className: 'black-60 f6 w-100 br2 ba',
                  id: 'searchMethod',
                  name: 'searchMethod',
                  size: 10,
                  multiple: true,
                  onchange: e => getSelectedOptions('searchMethod', dispatch, methodSelectUploadMsg),
              },
              model.constLists.searchMethods.map(
                  function (item, index) {
                      const selectedOption = model.upload.selectedMethod.includes(item.kode);
                      return option({ value: item.kode, selected: selectedOption }, item.text);
                  }
              )
          );
      }
      if (model.upload.selectArea === 'tabCenter') {
             return select({
                    className: 'black-60 f6 w-100 br2 ba',
                    id: 'searchCenter',
                    name: 'searchCenter',
                    size: 10,
                    multiple: true,
                    onchange: e => getSelectedOptions('searchCenter', dispatch, centerSelectUploadMsg),
                },
                model.constLists.searchCentres.map(
                    function (item, index) {
                        const selectedOption = model.upload.selectedCenter.includes(item.kode);
                        return option({ value: item.kode, selected: selectedOption }, item.text);
                    }
                )
            );
        }

    }

    function inputField(dispatch, fieldUploadMsg, id, value) {
        return input({
               className: 'pa2 input-reset ba br2 bg-transparent hover-black-80 w-100',
               id: id,
               type: 'text',
               value: value,
               oninput: e => dispatch(fieldUploadMsg(e.target.value)),
           });
    }
    function nextLinkLeft(tabName, label) {
        return a({ className: 'link dim dib pa1 pointer db inline-flex items-center f6 ba br2 b--black-50 border-box', onclick: () => dispatch(tabMsg(tabName)) }, [
            i( { className: 'fa fa-chevron-left fa black-70 mr1' }, ''),
            span( { className: 'black-70 mr1' }, label),
        ]);
    }
    function nextLinkRight(tabName, label) {
        return a({ className: 'link dim dib pa1 pointer db inline-flex items-center f6 ba br2 b--black-50 border-box', onclick: () => dispatch(tabMsg(tabName)) }, [
            span( { className: 'black-70' }, label),
            i( { className: 'ml1 fa fa-chevron-right fa black-70' }, ''),
        ]);
    }
    function highlight(model) {
        if (model.upload.dragHighlight)
            return 'mt1 b--purple bg-moon-gray ba bw1 b--dashed br2 pa1 h5 tc';
        return 'mt1 ba b--dashed br2 pa1 h5 tc';
    }
    function addFileUploadArea(dispatch, model) {
        return div( { className: highlight(model), id: 'drop-area',
              ondragenter: e => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(highlightDragMsg("on"));
              },
              ondragover: e => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(highlightDragMsg("on"));
              },
              ondragleave: e => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(highlightDragMsg("off"));
              },
              ondrop: e => {
                  e.preventDefault();
                  e.stopPropagation();
                  dispatch(highlightDragMsg("off"));
                  dispatch(dropDragMsg(e.dataTransfer.files));
              }
        }, [
            model.upload.fileNames.length > 0 ? span( { className: 'f5 black-50' }, model.upload.fileNames.join('\n') ) : span( { className: 'f5 black-50' }, 'Upload filer ved at trække dem hertil' ),
//            input( { className:'dn', type: 'file', id: 'fileElem', accept: '.pdf,.doc,.docx', multiple: true }),
//            label( { className: 'pa2 mb1', htmlFor: 'fileElem' }, 'Vælg filer')
        ]);
    }
    function addGeoFysProject(dispatch, model) {
        const btnDisabled = !model.upload.geoFysText ? 'disabled' : '';
        return div({  className: 'mv4' }, [
            p( { className: 'f4 fw6 ph0 mh0 mb2' } , 'Geofysiske projekter'),
            div({ className: 'di' },
                div({ className: 'w-100 mb1' }, [
                    label({ className: 'pa2 mb1', htmlFor: 'geoFysSearch' }, 'Find projekt'),
                    input({
                        id: 'geoFysSearch',
                        type: 'text',
                        placeholder: 'Projektnavn',
                        className: 'mr1 pa2 input-reset ba br2 bg-transparent hover-black-80',
                        value: model.upload.geoFysText,
                        oninput: e => dispatch(geoFysTextMsg(e.target.value)),
                    }),
                    getButton('Søg', '', btnDisabled, dispatch, getGeoFysTextSearchBtnMsg)
                ]),
            ),
            model.upload.geoFysTextSearchError ? div( { className: 'mb1'}, [
                i( { className: 'orange fa fa-exclamation-circle' }),
                label( { className: 'pa2 mb1 ml1 i black-50', id: 'GEOFYS' }, '' + model.upload.geoFysTextSearchError )
              ])
            : '',
            model.upload.geoFysList.length > 0 ? div({ className: 'mv3-ns' }, [
                select({
                        className: 'mt1 f6 black-60 mb2 w-100 br2 ba',
                        id: 'selectGeoFysProject',
                        name: 'selectGeoFysProject',
                        size: 5,
                        multiple: false,
                        onchange: e => dispatch(selectGeoFysMsg(e.target.value))
                    },
                    model.upload.geoFysList.map(item => option({ value: item.project }, item.project) )
                ),
                div({ className: 'overflow-hidden' },
                    getButton('Tilføj', ' fr', btnDisabled, dispatch, addGeoFysBtnMsg)
                )
            ]) : '',
            renderAddedList(dispatch, model.upload.addedGeoFysProject, 'Tilføjede projekter', removeAddedGeoFysProject)
        ]);
    }

    function addModelLink(dispatch, model) {
        const btnDisabled = !model.upload.modelLink ? 'disabled' : '';
        return div({  className: 'mv4' }, [
            p( { className: 'f4 fw6 ph0 mh0 mb2' } , 'Modeller'),
            div({ className: 'di' },
                div({ className: 'w-100 mb1' }, [
                    label({ className: 'pa2 mb1', htmlFor: 'modelLink' }, 'Tilføj model'),
                    input({
                        id: 'modelLink',
                        type: 'text',
                        placeholder: 'Link til model',
                        className: 'mr1 pa2 input-reset ba br2 bg-transparent hover-black-80',
                        value: model.upload.modelLink,
                        oninput: e => dispatch(modelLinkMsg(e.target.value)),
                    }),
                    getButton('Tilføj', '', btnDisabled, dispatch, addModelLinkBtnMsg)
                ]),
            ),
            model.upload.modelLinkError ? div( { className: 'mb1'}, [
                i( { className: 'orange fa fa-exclamation-circle' }),
                label( { className: 'pa2 mb1 ml1 i black-50', id: 'MODELLINK' }, '' + model.upload.modelLinkError )
              ])
            : '',
            renderAddedList(dispatch, model.upload.addedModelLink, 'Tilføjede modeller', removeAddedModelMsg)
        ]);
    }
    function renderAddedList(dispatch, addedList, title, removeMsg) {
        if (!addedList || addedList.length == 0) return '';

        return div( { className: '' }, [
                p( { className: 'pl2'}, title ),
                ul( { className: 'list'}, [ ...renderAddedListItems(dispatch, addedList, removeMsg) ] )
            ]);
    }
    function renderAddedListItems(dispatch, addedList, removeMsg) {
        const addedRenderedList = [];
        addedList.forEach( function render(item, index) {
            addedRenderedList.push(
                li( { className: 'bt b--black-30' },
                    div( { className: 'w-100 mb1'}, [
                        i( { className: 'green fa fa-check-circle' } ),
                        input( { className: 'w-80 f6 pa1 ml1 bn mb1 mr1 black-60', type: 'text', value: item, readOnly: true } ),
                        a( { className: 'black-60 dib link dim pointer f6-l f5', title: 'Fjern', onclick: () => dispatch(removeMsg(index))}, 'Fjern')
                    ])
                )
            );
        }) ;
        return addedRenderedList;
    }

    function addDguBoring(dispatch, model) {
        const btnDisabled = !model.upload.dguNr ? 'disabled' : '';
        return div({  className: 'mt2 mb4' }, [
            p( { className: 'f4 fw6 ph0 mh0 mb2' } , 'Boringer'),
            div({ className: 'di' },
                div({ className: 'w-100 mb1' }, [
                    label({ className: 'pa2-ns pa1 mb1', htmlFor: 'dguSearch' }, 'Find boring'),
                    input({
                        id: 'dguSearch',
                        type: 'text',
                        placeholder: 'DGU-nr.',
                        className: 'mr1 pa2-ns pa1 input-reset ba br2 bg-transparent hover-black-80',
                        value: model.upload.dguNr,
                        oninput: e => dispatch(dguUploadMsg(e.target.value)),
                    }),
                    getButton('Søg', '', btnDisabled, dispatch, getDguInfoMsg)

                ]),
            ),

            model.upload.dguNrError ? div( { className: 'mb1'}, [
                i( { className: 'orange fa fa-exclamation-circle' }),
                label( { className: 'pa2 mb1 ml1 i black-50', id: 'DGU' }, '' + model.upload.dguNrError )
              ])
            : '',
            model.upload.warnOverLimit ? div( { className: 'mb1'}, [
                i( { className: 'orange fa fa-exclamation-circle' }),
                label( { className: 'pa2 mb1 ml1 i black-50', id: 'DGU' }, ' Søgeresultatet gav over 150 resultater, men der vises maksimalt 150.' )
              ])
            : '',

            model.upload.dguList.length > 0 ? div({ className: 'mv3-ns' }, [
                select({
                        className: 'mt1 f6 black-60 mb2 w-100 br2 ba input-reset',
                        id: 'selectDgu',
                        name: 'selectDgu',
                        size: 5,
                        multiple: false,
                        onchange: e => dispatch(selectDguMsg(e.target.value))
                    },
                    model.upload.dguList.map(item => option({ value: item.boreholeid }, (item.boreholeno + ' (' + item.location + ')') ))
                ),
                div({ className: 'overflow-hidden' },
                    getButton('Tilføj', ' fr', btnDisabled, dispatch, addDguBtnMsg)
                )
            ]) : '',
            renderAddedList(dispatch, model.upload.addedDgu, 'Tilføjede boringer', removeDguMsg)
        ]);
    }

    function addGeoReference(dispatch, model) {
        const btnDisabled = !model.upload.addingWkt ? 'disabled' : '';

        return div({ className: 'mv4' }, [
            p( { className: 'f4 fw6 ph0 mh0 mb2' } , 'Georeferencer'),
            p({ className: 'pa2 mb1' }, 'Tilføj georeference ved tegne på kortet eller indtaste som WKT (i WGS84 reference system) i tekstfeltet under kortet og husk at klikke på Tilføj.'),
            div( { className: 'mb1 w-100 tc'}, [
                input({ id: 'ingen', type: 'radio', name: 'drawType', value: 'Ingen', checked: true, onchange: e => displayRadioValue(dispatch, geoRefDrawTypeMsg) }),
                label({ className: 'pa2 mb1', htmlFor: 'ingen' }, 'Ingen'),
                input({ id: 'polygon', type: 'radio', name: 'drawType', value: 'Polygon', onchange: e => displayRadioValue(dispatch, geoRefDrawTypeMsg) }),
                label({ className: 'pa2 mb1', htmlFor: 'polygon' }, 'Polygon'),
                input({ id: 'linje', type: 'radio', name: 'drawType', value: 'LineString', onchange: e => displayRadioValue(dispatch, geoRefDrawTypeMsg) }),
                label({ className: 'pa2 mb1', htmlFor: 'linje' }, 'Linje'),
                input( { id: 'punkt', type: 'radio', name: 'drawType', value: 'Point', onchange: e => displayRadioValue(dispatch, geoRefDrawTypeMsg) } ) ,
                label({ className: 'pa2 mb1', htmlFor: 'punkt' }, 'Punkt'),
            ]),
            div( { className: 'mb1 w-100 ba b--blue h5', id: 'map'}, ''),
            textarea({
                className: 'pa2 f7 code black-60 input-reset ba br2 bg-transparent hover-black-80 w-100',
                rows: 4,
                value: model.upload.addingWkt,
                oninput: e => dispatch(georefStringUploadMsg(e.target.value)),
            }),
            div({ className: 'overflow-hidden' },
                getButton('Tilføj', ' fr', btnDisabled, dispatch, georefUploadMsg)
            ),
            renderAddedList(dispatch, model.upload.wkt, 'Tilføjede georeferencer', removeWktMsg)
        ]);

    }
}